import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { LetModule } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

import { LogoMainComponent } from '@pp/common';
import { Account, Role, Team } from '@pp/core/entities';
import { PermissionsStore, StorageStore } from '@pp/core/store';

import { RateConditionsComponent } from '../rate-conditions';
import { ToggleAgentAccountSalesComponent } from './toggle-agent-account-sales/toggle-agent-account-sales.component';
import { UserCardComponent } from './user-card/user-card.component';
import { TeamSelectorComponent } from '../team-selector/team-selector.component';

@Component({
  imports: [
    TranslateModule,
    LetModule,
    UserCardComponent,
    RateConditionsComponent,
    LogoMainComponent,
    ToggleAgentAccountSalesComponent,
    TeamSelectorComponent,
  ],
  selector: 'pp-header, [ppHeader]',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  permissions = inject(PermissionsStore);
  storageStore = inject(StorageStore);

  readonly breakpoints = input<{
    isDesktop: boolean;
    isTablet: boolean;
  }>();
  readonly data = input<{
    title: string;
    user: Account;
  }>();

  readonly roleEnum = Role;

  getActiveOrg(organizations: Team[], orgId: number | unknown): Team {
    return organizations?.find(org => org.orgId === orgId);
  }
}
